export const KCACTION = {
    UPDATE_PASSWORD: 'UPDATE_PASSWORD',
    UPDATE_TOTP: 'CONFIGURE_TOTP',
    UPDATE_EMAIL: 'UPDATE_EMAIL',
    WEB_AUTH_PASSWORDLESS: 'webauthn-register-passwordless',
};
